import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NearbyAmenitiesComponent } from './nearby-amenities/nearby-amenities.component';
import { NearbyRoadsComponent } from './nearby-roads/nearby-roads.component';
import { NearbyInfo } from '../../models/response-nearby-data';

@Component({
  selector: 'app-response-nearby-data',
  standalone: true,
  imports: [CommonModule, NearbyAmenitiesComponent, NearbyRoadsComponent],
  templateUrl: './response-nearby-data.component.html'
})
export class ResponseNearbyDataComponent {
  @Input() response: NearbyInfo | null = null;
 
}
